"use strict";
import {
  addClassWithScroll as scroll
} from "./common/_scroll-event";
import {
  addClassWithScrollSingleElement as singleScroll
} from "./common/_scroll-event";

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    scroll(
      ".information-list__img",
      ".information-list__fig",
      "is-anime",
      "8"
    );
    scroll(
      ".information-list__cloud",
      ".information-list__fig",
      "is-anime",
      "8"
    );
    singleScroll(
      ".information-faq__item",
      "is-anime",
      "4"
    );
  },
  false
);
